import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue'; 

let service = new services();
export default {
    name: 'Home',
    data () {
        return {
            user:{},
            market:{},
            products: {},
            product: {},
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
    },
    computed: {
        total() {
          var total = 0;
          for(var i = 0; i < this.items.length; i++) {
            total += this.items[i].product_price;
          }
          return total;
        }
    },
    methods: {
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                           this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        setMarketRemote(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data; 
                    this.loading = false;
                //    this.getProducts();
                }
            }).catch((err) => {
                //maybe no connection ..load from local
               // this.setSellpointLocal(); //removed...caused slower loading
            })
            
        },
    
        
    },
    created: function(){
        this.preset();
        this.setMarketRemote();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Businesses/script.js